import styled from '@emotion/styled';
import { typography } from '@uniquegood/realworld-studio-design';

interface PlanBadgeProps {
  plan: PlanType;
}

const PLAN_LABELS: Record<PlanType, string> = {
  Free: 'Free',
  Pro: 'Pro',
  Enterprise: 'Enterprise',
  Class: 'Class',
  Teacher: 'Teacher',
  Realworld: 'Realworld'
};

const PlanBadge = ({ plan }: PlanBadgeProps) => {
  if (!plan) {
    return <Badge plan="Realworld">Realworld</Badge>;
  }

  return <Badge plan={plan}>{PLAN_LABELS[plan]}</Badge>;
};

export default PlanBadge;

const getBadgeColorAndBackground = (plan: PlanType | 'Realworld') => {
  if (plan === 'Free') {
    return { color: '#666666', background: '#E8E8E8' };
  }

  if (plan === 'Realworld') {
    return { color: '#ffffff', background: '#1A1A1A' };
  }

  return { color: '#ffffff', background: 'linear-gradient(90deg, #7800ff 0%, #829bff 100%)' };
};

const Badge = styled.div<{ plan: PlanType | 'Realworld' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 6px;
  background: ${({ plan }) => getBadgeColorAndBackground(plan).background};
  color: ${({ plan }) => getBadgeColorAndBackground(plan).color};
  font-size: 12px;
  line-height: 16px;
  font-weight: ${typography.weight.bold};
  white-space: nowrap;
`;
